<template>
  <div class="card card-fluid">
    <div class="card-body">
      <h2 class="card-title">Protocolos</h2>
      <div class="table-responsive">
        <dynamic-table :columns="columns"
                       :data="protocols"
                       :loading="loading"
                       :paginationData="paginationData"
                       class="table-hover"
                       empty-message="No se encontraron resultados"
                       theadClass="thead-light"
                       @update-table-data="updateTableData">
          <template v-slot:options="slotProps">
            <a v-if="slotProps.row.status_key === 'reg'"
               :href="`/protocolo/${slotProps.row.id}`"
               class="btn btn-sm btn-outline-primary d-block"
               style="white-space: nowrap">Editar protocolo
            </a>
            <a v-else
               :href="`/protocolo/${slotProps.row.id}/consultar`"
               class="btn btn-sm btn-outline-primary d-block"
               style="white-space: nowrap">Ver protocolo
            </a>
          </template>
        </dynamic-table>
      </div>
    </div>
  </div>
</template>

<script>
  import DynamicTable from '../ui/DynamicTable'
  
  export default {
    name: 'Protocols',
    components: {
      DynamicTable,
    },
    props: {
      protocols: {
        type: Array,
        default: () => ([]),
      },
      paginationData: {
        type: Object,
        default: () => ({}),
      },
    },
    data () {
      return {
        loading: false,
        columns: [
          {
            field: 'id',
            title: 'Id',
            tdClass: 'text-left',
            tdStyle: {},
            thClass: 'align-middle',
            thStyle: {},
          }, {
            field: 'title',
            title: 'Título',
            tdClass: 'text-left text-truncate',
            tdStyle: {
              'max-width': '200px',
            },
            thClass: 'align-middle',
            thStyle: {},
          }, {
            field: 'summary',
            title: 'Resumen',
            tdClass: 'text-left text-truncate',
            tdStyle: {
              'max-width': '200px',
            },
            thClass: 'align-middle',
            thStyle: {},
          }, {
            field: 'options',
            title: 'Opciones',
            tdClass: 'text-left text-truncate',
            tdStyle: {},
            thClass: 'align-middle',
            thStyle: {},
          }],
      }
    },
    methods: {
      updateTableData (data, paginationData) {
        this.$emit('update-table-data', data, paginationData)
      },
    },
  }
</script>
